exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "form {\n  padding: 15px;\n  border: 5px solid #ad0e68;\n  border-radius: 5px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/leonhard/Projekte/braungardt/angular/src/app/newsletter/newsletter.component.scss
// module id = ../../../../../src/app/newsletter/newsletter.component.scss
// module chunks = main